import { CHANGE_TITLE } from '../actions/types'

const initialState = {}

const titleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_TITLE:
      return action.payload
    default:
      return state
  }
}

export default titleReducer
